module.exports = __webpack_public_path__ + "static/media/U16.97532b57.jpg";